import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { HttpUtils } from "../shared/http.utils";
import { EncoderFilters } from "../model/filters/encoder-filters";
import { EncodersResponse } from "../model/responses/encoders-response";
import { EncoderPersistRequest } from "../model/requests/encoder-persist-request";

@Injectable({
  providedIn: 'root'
})
export class EncodersService {

  private readonly encodersURL: string;

  constructor(private http: HttpClient) {
    this.encodersURL = "/catalog/encoders";
  }

  public getEncoders(offset?: number, limit?: number, filters?: EncoderFilters): Observable<EncodersResponse>{
    let options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    let body = (filters != null) ? filters : new EncoderFilters();
    return this.http.post<EncodersResponse>(this.encodersURL, body, options);
  }

  public createEncoder(encoderCreationData: EncoderPersistRequest) {
    let url = `${this.encodersURL}/create`;
    return this.http.post<any>(url, encoderCreationData);
  }

  public editEncoder(encoderCreationData: EncoderPersistRequest) {
    let url = `${this.encodersURL}/edit`;
    return this.http.post<any>(url, encoderCreationData);
  }

  public deleteEncoders(identifiers: {tenantUuid: string, name: string}[]) {
    let url = `${this.encodersURL}/delete`;
    return this.http.post<any>(url, identifiers, {observe: 'response'});
  }

}
